// components
import {
  Box,
  BoxProps,
  styled,
  Typography,
  TypographyProps
} from '@mui/material';
import {
  GridRenderCellParams,
  GridTreeNodeWithRender,
  GridValidRowModel
} from '@mui/x-data-grid-pro';

export type GridCellParams = {
  params: GridRenderCellParams<
    GridValidRowModel,
    any,
    any,
    GridTreeNodeWithRender
  >;
};

export const StyledPercentageLabelTypography = styled(
  Typography
)<TypographyProps>(() => ({
  minWidth: '32px',
  textAlign: 'right'
}));
export const StyledPercentageBarContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'params'
})<BoxProps & GridCellParams>(({ theme, params }) => ({
  width: '100%',
  height: '12px',
  backgroundColor:
    params.value === 0
      ? theme.vars.palette.info.container
      : theme.vars.palette.divider,
  overflow: 'hidden',
  borderRadius: theme.shape.borderRadius
}));

export const StyledPercentageBarContainerBar = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'params'
})<BoxProps & GridCellParams>(({ theme, params }) => ({
  width: `${params.value}%`,
  backgroundColor: theme.vars.palette.success.light,
  height: '100%'
}));

export const StyledNotificationDot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isAvailable'
})<BoxProps & { isAvailable: boolean }>(({ theme, isAvailable }) => ({
  display: 'flex',
  width: '10px',
  height: '10px',
  borderRadius: '50%',
  backgroundColor: isAvailable
    ? theme.vars.palette.success.main
    : theme.vars.palette.error.main
}));
